<template>
  <v-app style="background-color: #f3f6f9">
    <v-main>
    <nav-bar :balanceChanged="balance"></nav-bar>
    <CreateEsim />
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/components/widgets/navBar.vue'
import CreateEsim from '@/components/seller/CreateEsim.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: {
    NavBar,
    CreateEsim
  },
  data() {
    return {
      balance: 0,
    }
  },
  mounted() {
    document.title = 'Create ESIM | ISRASIM'

    let auth = Auth.checkAuth();
      if (!auth) {
        this.$router.replace({ name: "login" })
      }
  },
}
</script>
  